var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noList"},[_c('img',{attrs:{"src":require("../../assets/Nolist/noList.png"),"alt":""}}),_vm._t("text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }